// Generated by AvenyModelEditor

import { IClientSubSystemModel } from '../../Types/ClientModelTypes';
import { TEDSelectionOperator as T} from '../../globalQueryTypes';

const LA: IClientSubSystemModel = {
  Code: 'LA',
  DisplayLabel: 'Lager',
  BusinessModels: {
    LAArtikelgrupp: {
      CollectionName: 'LAArtikelgrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '9003']]),
      RootType: {
        TypeValue: 'Artikelgrupp',
        Abstract: false,
        SOLabel: 'Artikelgrupp',
        SOGLabel: 'Artikelgrupp',
        SBLabel: 'Artikelgruppen',
        SBGLabel: 'Artikelgruppen',
        POLabel: 'Artikelgrupper',
        POGLabel: 'Artikelgrupper',
        PBLabel: 'Artikelgrupperna',
        PBGLabel: 'Artikelgrupperna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Artikelgruppen primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Artikelgruppen versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Artikelgruppen id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Artikelgruppen fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTIKELGRUPP: {
          AttributeName: 'ARTIKELGRUPP',
          DisplayLabel: 'Artikelgrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 8,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Properties: new Map([['ConditionShowValues', 'True;'], ['ConditionShowValuesHintAttribute', 'BENAMNING;']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 30,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Properties: new Map([['ConditionShowValues', 'True;']]),
          Required: true,
        },
        KBIntaktskonto: {
          AttributeName: 'KBIntaktskonto',
          DisplayLabel: 'Intäktskonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Intaktskonto: {
          AttributeName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FaktuGrupper: {
          AttributeName: 'FaktuGrupper',
          DisplayLabel: 'Faktureringsgrupper',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Intaktskonto: {
          AssociationName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Fakturatext: {
          AssociationName: 'Fakturatext',
          DisplayLabel: 'Fakturatext',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAFakturatext',
          AssociatedComponentName: 'Fakturatext',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        FaktGrupp: {
          AssociationName: 'FaktGrupp',
          DisplayLabel: 'Artikelgruppens faktureringsgrupper',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtGruppFaktgrupp',
          AssociatedComponentName: 'ArtgruppFaktGrupp',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LAArtGruppFaktgrupp: {
      CollectionName: 'LAArtGruppFaktgrupp',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArtgruppFaktGrupp',
        Abstract: false,
        SOLabel: 'Artikelgrupp faktureringsgrupp',
        SOGLabel: 'Artikelgrupp faktureringsgrupp',
        SBLabel: 'Artikelgruppens faktureringsgrupp',
        SBGLabel: 'Artikelgruppens faktureringsgrupp',
        POLabel: 'Artikelgruppernas faktureringsgrupper',
        POGLabel: 'Artikelgruppernas faktureringsgrupper',
        PBLabel: 'Artikelgruppernas faktureringsgrupper',
        PBGLabel: 'Artikelgruppernas faktureringsgrupper',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Artikelgruppens faktureringsgrupp primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Artikelgruppens faktureringsgrupp versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Artikelgruppens faktureringsgrupp id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Artikelgruppens faktureringsgrupp fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Faktureringsgrupp: {
          AttributeName: 'Faktureringsgrupp',
          DisplayLabel: 'Faktureringsgrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Artikelgrupp: {
          AttributeName: 'Artikelgrupp',
          DisplayLabel: 'Artikelgrupp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Artikelgrupp: {
          AssociationName: 'Artikelgrupp',
          DisplayLabel: 'Artikelgrupp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikelgrupp',
          AssociatedComponentName: 'Artikelgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Faktureringsgrupp: {
          AssociationName: 'Faktureringsgrupp',
          DisplayLabel: 'Faktureringsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfgruppFakt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    LAArtikel: {
      CollectionName: 'LAArtikel',
      UDAEnabled: true,
      UDNEnabled: true,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '9001'], ['AllowSelection', '21001']]),
      RootType: {
        TypeValue: 'Artikel',
        Abstract: true,
        SOLabel: 'Artikel',
        SOGLabel: 'Artikel',
        SBLabel: 'Artikeln',
        SBGLabel: 'Artikeln',
        POLabel: 'Artiklar',
        POGLabel: 'Artiklar',
        PBLabel: 'Artiklarna',
        PBGLabel: 'Artiklarna',
        Visible: true,
        ChildTypes: [
          {
            TypeValue: 'VaraTjanst',
            Abstract: true,
            SOLabel: 'Vara/Tjänst',
            SOGLabel: 'Vara/Tjänst',
            SBLabel: 'Vara/Tjänsten',
            SBGLabel: 'Vara/Tjänsten',
            POLabel: 'Vara/Tjänster',
            POGLabel: 'Vara/Tjänster',
            PBLabel: 'Vara/Tjänsterna',
            PBGLabel: 'Vara/Tjänsterna',
            Visible: true,
            ChildTypes: [
              {
                TypeValue: 'Vara',
                Abstract: false,
                SOLabel: 'Vara',
                SOGLabel: 'Vara',
                SBLabel: 'Varan',
                SBGLabel: 'Varan',
                POLabel: 'Varor',
                POGLabel: 'Varor',
                PBLabel: 'Varorna',
                PBGLabel: 'Varorna',
                Visible: true,
                ChildTypes: [
                ],
              },
              {
                TypeValue: 'Tjanst',
                Abstract: false,
                SOLabel: 'Tjänst',
                SOGLabel: 'Tjänst',
                SBLabel: 'Tjänsten',
                SBGLabel: 'Tjänsten',
                POLabel: 'Tjänster',
                POGLabel: 'Tjänster',
                PBLabel: 'Tjänsterna',
                PBGLabel: 'Tjänsterna',
                Visible: true,
                ChildTypes: [
                ],
              },
            ],
          },
          {
            TypeValue: 'Avgift',
            Abstract: false,
            SOLabel: 'Avgift',
            SOGLabel: 'Avgift',
            SBLabel: 'Avgiften',
            SBGLabel: 'Avgiften',
            POLabel: 'Avgifter',
            POGLabel: 'Avgifter',
            PBLabel: 'Avgifterna',
            PBGLabel: 'Avgifterna',
            Visible: true,
            ChildTypes: [
            ],
          },
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Artikeln primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Artikeln versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _typ: {
          AttributeName: '_typ',
          DisplayLabel: 'Typ',
          DataType: 'Enum',
          EnumValues: new Map([['VARA', 'Vara'], ['TJANST', 'Tjänst'], ['AVGIFT', 'Avgift']]),
          EnumSortValues: new Map([['VARA', 'V'], ['TJANST', 'T'], ['AVGIFT', 'A']]),
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifTypeTree',
          Required: true,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Artikeln id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Artikeln fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTIKELNR: {
          AttributeName: 'ARTIKELNR',
          DisplayLabel: 'Artikelnummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 12,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        MOMS_ID: {
          AttributeName: 'MOMS_ID',
          DisplayLabel: 'Momskod',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTIKELGRUPP_ID: {
          AttributeName: 'ARTIKELGRUPP_ID',
          DisplayLabel: 'Artikelgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        RABATT: {
          AttributeName: 'RABATT',
          DisplayLabel: 'Rabatt',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatIntAsPercent',
        },
        SORTIMENT: {
          AttributeName: 'SORTIMENT',
          DisplayLabel: 'Sortiment',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 10,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True']]),
        },
        EJ_ORDERRABATT: {
          AttributeName: 'EJ_ORDERRABATT',
          DisplayLabel: 'Ej orderrabatt',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        VARLEV1_ID: {
          AttributeName: 'VARLEV1_ID',
          DisplayLabel: 'Vår leverantör 1',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        VARLEV2_ID: {
          AttributeName: 'VARLEV2_ID',
          DisplayLabel: 'Vår leverantör 2',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LEVARTNR1: {
          AttributeName: 'LEVARTNR1',
          DisplayLabel: 'Artikelnr, leverantör 1',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        LEVARTNR2: {
          AttributeName: 'LEVARTNR2',
          DisplayLabel: 'Artikelnr, leverantör 2',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeGroup: 'Övrigt',
        },
        FRSKMANAD: {
          AttributeName: 'FRSKMANAD',
          DisplayLabel: 'Månad, från',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Gravskötsel',
        },
        TISKMANAD: {
          AttributeName: 'TISKMANAD',
          DisplayLabel: 'Månad, till',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Gravskötsel',
        },
        ANVPRISLISTA: {
          AttributeName: 'ANVPRISLISTA',
          DisplayLabel: 'Automatisk prisuppdatering',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Gravskötsel',
        },
        EJ_ARBETSUNDERLAG: {
          AttributeName: 'EJ_ARBETSUNDERLAG',
          DisplayLabel: 'Ej på arbetsunderlag',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Gravskötsel',
        },
        SKOTNOTFAKT: {
          AttributeName: 'SKOTNOTFAKT',
          DisplayLabel: 'Skötselnotering på faktura',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
        },
        PAKET: {
          AttributeName: 'PAKET',
          DisplayLabel: 'Paketartikel',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Gravskötsel',
        },
        PAKETSPECFAKT: {
          AttributeName: 'PAKETSPECFAKT',
          DisplayLabel: 'Paket specifierat på faktura',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          FormatterParseParams: 'FalseText="Nej";TrueText="Ja"',
          FormatterDisplayParams: 'FalseText="Nej";TrueText="Ja"',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          AttributeGroup: 'Gravskötsel',
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        KOBARTIKEL: {
          AttributeName: 'KOBARTIKEL',
          DisplayLabel: 'KOB-artikel',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        KOBARTIKEL_ID: {
          AttributeName: 'KOBARTIKEL_ID',
          DisplayLabel: 'KOB-artikel ID',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BenamningShort: {
          AttributeName: 'BenamningShort',
          DisplayLabel: 'Kort benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        calcArtikelgrupp: {
          AttributeName: 'calcArtikelgrupp',
          DisplayLabel: 'Artikelgrupp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        calcMomskod: {
          AttributeName: 'calcMomskod',
          DisplayLabel: 'Momskod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Artikeltyp: {
          AttributeName: 'Artikeltyp',
          DisplayLabel: 'Artikeltyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        KBIntaktskonto: {
          AttributeName: 'KBIntaktskonto',
          DisplayLabel: 'Intäktskonto',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Intaktskonto: {
          AttributeName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Pris: {
          AttributeName: 'Pris',
          DisplayLabel: 'Pris',
          DataType: 'Currency',
          Attribute: 'Internal',
          Condition: 'None',
          AttributeParams: {'Prislista': {type: 'Int', defaultValue: ''}, 'PrisPerDatum': {type: 'Date', defaultValue: ''}},
        },
        Forrattningstyp: {
          AttributeName: 'Forrattningstyp',
          DisplayLabel: 'Förrättningstyp',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        RuleID: {
          AttributeName: 'RuleID',
          DisplayLabel: 'RuleID',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ENHET_ID: {
          AttributeName: 'ENHET_ID',
          DisplayLabel: 'Enhet',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['VaraTjanst'],
        },
        calcEnhet: {
          AttributeName: 'calcEnhet',
          DisplayLabel: 'Enhet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['VaraTjanst'],
        },
        EnhetAntalDec: {
          AttributeName: 'EnhetAntalDec',
          DisplayLabel: 'Antal decimaler',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['VaraTjanst'],
        },
        Enhet: {
          AttributeName: 'Enhet',
          DisplayLabel: 'Enhet',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
          ValidInComps: ['VaraTjanst'],
        },
        LAGERPLATS: {
          AttributeName: 'LAGERPLATS',
          DisplayLabel: 'Lagerplats',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
          ValidInComps: ['Vara'],
          AttributeGroup: 'Vara',
        },
        LAGERANTAL: {
          AttributeName: 'LAGERANTAL',
          DisplayLabel: 'Antal i lager',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Vara'],
          AttributeGroup: 'Vara',
        },
        BESTALLNINGSPKT: {
          AttributeName: 'BESTALLNINGSPKT',
          DisplayLabel: 'Beställningspunkt',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Vara'],
          AttributeGroup: 'Vara',
        },
        BESTKVANT: {
          AttributeName: 'BESTKVANT',
          DisplayLabel: 'Beställningskvantitet',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          ValidInComps: ['Vara'],
          AttributeGroup: 'Vara',
        },
        KodBenamning: {
          AttributeName: 'KodBenamning',
          DisplayLabel: 'Artikelnr och benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        AktuelltPris: {
          AttributeName: 'AktuelltPris',
          DisplayLabel: 'Aktuellt pris',
          Hint: 'Pris per dagens datum enligt standardprislistan',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
          AttributeGroup: 'Artikelpris',
        },
        ENGANGSARTIKEL: {
          AttributeName: 'ENGANGSARTIKEL',
          DisplayLabel: 'Engångsartikel',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TEMP_GAS_ARTIKELGRUPP_ID: {
          AttributeName: 'TEMP_GAS_ARTIKELGRUPP_ID',
          DisplayLabel: 'Temporär artikelgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BenNummer: {
          AttributeName: 'BenNummer',
          DisplayLabel: 'Benamning Nummer',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        TEMP_PREV_ARTIKELGRUPP_ID: {
          AttributeName: 'TEMP_PREV_ARTIKELGRUPP_ID',
          DisplayLabel: 'Artikelgrupp före GAS',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        NummerBen: {
          AttributeName: 'NummerBen',
          DisplayLabel: 'NummerBen',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        PrislistaPris: {
          AttributeName: 'PrislistaPris',
          DisplayLabel: 'Pris enligt prislista',
          Hint: 'Pris enligt vald prislista och valt datum',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatCurr',
          AttributeGroup: 'Artikelpris',
          AttributeParams: {'Kalkylprislista': {type: 'Int', defaultValue: '-1'}, 'Kalkylprisdatum': {type: 'Date', defaultValue: ''}},
        },
        VANVARD: {
          AttributeName: 'VANVARD',
          DisplayLabel: 'Vanvård',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        TrimBenamning: {
          AttributeName: 'TrimBenamning',
          DisplayLabel: 'Trimbenamning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXT_BESKRIVNING: {
          AttributeName: 'EXT_BESKRIVNING',
          DisplayLabel: 'Extern beskrivning',
          Hint: 'Artikelbeskrivning som visas vid skötselbeställning på SvenskaGravar.se',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Beställning',
        },
        BRYTDATUM: {
          AttributeName: 'BRYTDATUM',
          DisplayLabel: 'Beställningsbar fr.o.m',
          Hint: 'Beställningsbar inför nästa år fr.o.m. Gäller på SvenskaGravar.se',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Beställning',
        },
        BESTALLNINGSBAR_FR: {
          AttributeName: 'BESTALLNINGSBAR_FR',
          DisplayLabel: 'Beställningsbar fr.o.m',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          AttributeGroup: 'Beställning',
        },
        BESTALLNINGSBAR_TI: {
          AttributeName: 'BESTALLNINGSBAR_TI',
          DisplayLabel: 'Beställningsbar t.o.m',
          Hint: 'Beställningsbar för innevarande år t.o.m. Gäller på SvenskaGravar.se',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          AttributeGroup: 'Beställning',
        },
        BrytdatumText: {
          AttributeName: 'BrytdatumText',
          DisplayLabel: 'Beställningsbar fr.o.m',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Beställning',
        },
        BestallningsbarTiText: {
          AttributeName: 'BestallningsbarTiText',
          DisplayLabel: 'Beställningsbar t.o.m',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          AttributeGroup: 'Beställning',
        },
        BESTALLNINGSGRUPP: {
          AttributeName: 'BESTALLNINGSGRUPP',
          DisplayLabel: 'Beställningsgrupp',
          Hint: 'Det går bara att beställa en av artiklarna ur beställningsgruppen vid beställning på svenskagravar.se',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 20,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          AttributeGroup: 'Beställning',
        },
        LOVET_WEBGRAV: {
          AttributeName: 'LOVET_WEBGRAV',
          DisplayLabel: 'Administrativ artikel',
          Hint: 'Visas på skötselrader men aktiverar inte lövet i WebGrav - Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatBool',
          GUIEditable: true,
          InterfaceType: 'ifBoolean',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Blob: {
          AssociationName: 'Blob',
          DisplayLabel: 'Blob',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikelBlob',
          AssociatedComponentName: 'ArtikelBlob',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: true,
          Properties: new Map([]),
        },
        Artikelgrupp: {
          AssociationName: 'Artikelgrupp',
          DisplayLabel: 'Artikelgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikelgrupp',
          AssociatedComponentName: 'Artikelgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
        Moms: {
          AssociationName: 'Moms',
          DisplayLabel: 'Moms',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSMoms',
          AssociatedComponentName: 'Moms',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Varlev1: {
          AssociationName: 'Varlev1',
          DisplayLabel: 'Vår leverantör 1',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRLeverantor',
          AssociatedComponentName: 'Leverantor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Varlev2: {
          AssociationName: 'Varlev2',
          DisplayLabel: 'Vår leverantör 2',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LRLeverantor',
          AssociatedComponentName: 'Leverantor',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Intaktskonto: {
          AssociationName: 'Intaktskonto',
          DisplayLabel: 'Intäktskonto',
          Attribute: 'Internal',
          Condition: 'Normal',
          AssociatedCollectionName: 'EKKonteringsvarde',
          AssociatedComponentName: 'Konteringsvarde',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Faktureringsgrupp: {
          AssociationName: 'Faktureringsgrupp',
          DisplayLabel: 'Faktureringsgrupp',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSGrupp',
          AssociatedComponentName: 'BokfgruppFakt',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        KOBArtikel: {
          AssociationName: 'KOBArtikel',
          DisplayLabel: 'Clearingartikel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'SYSKOBArtikel',
          AssociatedComponentName: 'KOBArtikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Enhet: {
          AssociationName: 'Enhet',
          DisplayLabel: 'Enhet',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAEnhet',
          AssociatedComponentName: 'Enhet',
          JoinAssociation: true,
          ValidInComps: ['VaraTjanst'],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        TempGASArtikelgrupp: {
          AssociationName: 'TempGASArtikelgrupp',
          DisplayLabel: 'Flyttas till artikelgrupp i GAS',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikelgrupp',
          AssociatedComponentName: 'Artikelgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        ArtikelgruppForeGAS: {
          AssociationName: 'ArtikelgruppForeGAS',
          DisplayLabel: 'Artikelgrupp före GAS',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikelgrupp',
          AssociatedComponentName: 'Artikelgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Priser: {
          AssociationName: 'Priser',
          DisplayLabel: 'Priser',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAPriser',
          AssociatedComponentName: 'Priser',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Dokument: {
          AssociationName: 'Dokument',
          DisplayLabel: 'Dokument',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikelActiveX',
          AssociatedComponentName: 'ArtikelActiveX',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Orderrad: {
          AssociationName: 'Orderrad',
          DisplayLabel: 'Orderrader',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'OFOrderrad',
          AssociatedComponentName: 'Orderrad',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Skotsel: {
          AssociationName: 'Skotsel',
          DisplayLabel: 'Skötslar',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'GASkotsel',
          AssociatedComponentName: 'Skotsel',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Paket: {
          AssociationName: 'Paket',
          DisplayLabel: 'Paket',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikelPaket',
          AssociatedComponentName: 'ArtikelPaket',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LAArtikelBlob: {
      CollectionName: 'LAArtikelBlob',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArtikelBlob',
        Abstract: false,
        SOLabel: '',
        SOGLabel: '',
        SBLabel: '',
        SBGLabel: '',
        POLabel: '',
        POGLabel: '',
        PBLabel: '',
        PBGLabel: '',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'LAArtikelBlobs primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'LAArtikelBlobs versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'LAArtikelBlobs id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'LAArtikelBlobs fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SKOTNOT: {
          AttributeName: 'SKOTNOT',
          DisplayLabel: 'Skötselnotering',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILD: {
          AttributeName: 'BILD',
          DisplayLabel: 'Bild',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILDSIZE: {
          AttributeName: 'BILDSIZE',
          DisplayLabel: 'Bild',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BILDSTRETCH: {
          AttributeName: 'BILDSTRETCH',
          DisplayLabel: 'Bild',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
      },
    },
    LAArtikelActiveX: {
      CollectionName: 'LAArtikelActiveX',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'ArtikelActiveX',
        Abstract: false,
        SOLabel: 'Dokument',
        SOGLabel: 'Dokument',
        SBLabel: 'Dokumentet',
        SBGLabel: 'Dokumentet',
        POLabel: 'Dokument',
        POGLabel: 'Dokument',
        PBLabel: 'Dokumenten',
        PBGLabel: 'Dokumenten',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Dokumentet primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Dokumentet versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Dokumentet id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Dokumentet fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          Properties: new Map([['EXPORTABLE_KEY', 'Y;']]),
        },
        BESKRIVNING: {
          AttributeName: 'BESKRIVNING',
          DisplayLabel: 'Beskrivning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 100,
        },
        DATA: {
          AttributeName: 'DATA',
          DisplayLabel: 'Data',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'None',
        },
        DATASIZE: {
          AttributeName: 'DATASIZE',
          DisplayLabel: 'Datastorlek',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
        },
        DATATYPE: {
          AttributeName: 'DATATYPE',
          DisplayLabel: 'Datatyp',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        EXTENSION: {
          AttributeName: 'EXTENSION',
          DisplayLabel: 'Filändelse',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Internal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LAEnhet: {
      CollectionName: 'LAEnhet',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '9002'], ['AllowSelection', '2060']]),
      RootType: {
        TypeValue: 'Enhet',
        Abstract: false,
        SOLabel: 'Enhet',
        SOGLabel: 'Enhet',
        SBLabel: 'Enheten',
        SBGLabel: 'Enheten',
        POLabel: 'Enheter',
        POGLabel: 'Enheter',
        PBLabel: 'Enheterna',
        PBGLabel: 'Enheterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Enheten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Enheten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Enheten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Enheten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ENHET: {
          AttributeName: 'ENHET',
          DisplayLabel: 'Enhet',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Properties: new Map([['ConditionShowValues', 'True;']]),
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        ANTALDEC: {
          AttributeName: 'ANTALDEC',
          DisplayLabel: 'Antal decimaler',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          FormatterValidateParams: 'MinValue="0";MaxValue="10"',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        EK: {
          AttributeName: 'EK',
          DisplayLabel: 'Används i Ekonomi',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        LA: {
          AttributeName: 'LA',
          DisplayLabel: 'Används i Order/Fakturering',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        TI: {
          AttributeName: 'TI',
          DisplayLabel: 'Används i Tidredovisning',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        TI_INTRED_TIM: {
          AttributeName: 'TI_INTRED_TIM',
          DisplayLabel: 'Används för internredovisning av timmar',
          Hint: 'Ja/Nej',
          DataType: 'Enum',
          EnumValues: new Map([['JA', 'Ja'], ['NEJ', 'Nej']]),
          EnumSortValues: new Map([['JA', 'Y'], ['NEJ', 'N']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="JA=Ja;NEJ=Nej"',
          GUIEditable: true,
        },
        IMPORT_BENAMNING: {
          AttributeName: 'IMPORT_BENAMNING',
          DisplayLabel: 'Import, benämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Tjanst',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LAFakturatext: {
      CollectionName: 'LAFakturatext',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['USER_DEF_REPORT_ROUTINE', '9005']]),
      RootType: {
        TypeValue: 'Fakturatext',
        Abstract: false,
        SOLabel: 'Fakturatext',
        SOGLabel: 'Fakturatext',
        SBLabel: 'Fakturatexten',
        SBGLabel: 'Fakturatexten',
        POLabel: 'Fakturatexter',
        POGLabel: 'Fakturatexter',
        PBLabel: 'Fakturatexterna',
        PBGLabel: 'Fakturatexterna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Fakturatexten primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Fakturatexten versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Fakturatexten id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Fakturatexten fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        SORTKOD: {
          AttributeName: 'SORTKOD',
          DisplayLabel: 'Standardtextnr',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 6,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
          Required: true,
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 255,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
        },
        ARTIKELGRUPP_ID: {
          AttributeName: 'ARTIKELGRUPP_ID',
          DisplayLabel: 'Artikelgrupp',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BenamningShort: {
          AttributeName: 'BenamningShort',
          DisplayLabel: 'Kort benämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        calcArtikelgrupp: {
          AttributeName: 'calcArtikelgrupp',
          DisplayLabel: 'ArtikelgruppKod',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Artikelgrupp: {
          AssociationName: 'Artikelgrupp',
          DisplayLabel: 'Artikelgrupp',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikelgrupp',
          AssociatedComponentName: 'Artikelgrupp',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    LAArtikelPaket: {
      CollectionName: 'LAArtikelPaket',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'ArtikelPaket',
        Abstract: false,
        SOLabel: 'Paketartikel',
        SOGLabel: 'Paketartikel',
        SBLabel: 'Paketartikeln',
        SBGLabel: 'Paketartikeln',
        POLabel: 'Paketartiklar',
        POGLabel: 'Paketartiklar',
        PBLabel: 'Paketartiklarna',
        PBGLabel: 'Paketartiklarna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Paketartikeln primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Paketartikeln versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Paketartikeln fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        ARTIKEL_ID: {
          AttributeName: 'ARTIKEL_ID',
          DisplayLabel: 'Id, artikel',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
        },
        LOPNR: {
          AttributeName: 'LOPNR',
          DisplayLabel: 'Löpnummer',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        INGAENDE_ARTIKEL_ID: {
          AttributeName: 'INGAENDE_ARTIKEL_ID',
          DisplayLabel: 'Id, ingående artikel',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ANTAL: {
          AttributeName: 'ANTAL',
          DisplayLabel: 'Antal',
          DataType: 'Float',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatFloat',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
        },
        MANAD: {
          AttributeName: 'MANAD',
          DisplayLabel: 'Månad',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        ARTIKELGRUPP_ID: {
          AttributeName: 'ARTIKELGRUPP_ID',
          DisplayLabel: 'Id, artikelgrupp',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        DAG: {
          AttributeName: 'DAG',
          DisplayLabel: 'Dag',
          DataType: 'Int',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatInt',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.interval,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Ingående artikel',
          Attribute: 'Normal',
          Condition: 'Normal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: true,
          Properties: new Map([]),
          Required: true,
        },
      },
    },
    LAPriser: {
      CollectionName: 'LAPriser',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([]),
      RootType: {
        TypeValue: 'Priser',
        Abstract: false,
        SOLabel: 'Pris',
        SOGLabel: 'Pris',
        SBLabel: 'Priset',
        SBGLabel: 'Priset',
        POLabel: 'Priser',
        POGLabel: 'Priser',
        PBLabel: 'Priserna',
        PBGLabel: 'Priserna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Priset primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Priset versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Priset id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Priset fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FRANDATUM: {
          AttributeName: 'FRANDATUM',
          DisplayLabel: 'Från datum',
          DataType: 'Date',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        PRIS: {
          AttributeName: 'PRIS',
          DisplayLabel: 'Pris',
          DataType: 'Currency',
          Attribute: 'Normal',
          Condition: 'Normal',
          Formatter: 'TEDFormatCurr',
          GUIEditable: true,
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        Artikelnr: {
          AttributeName: 'Artikelnr',
          DisplayLabel: 'Artikelnr',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        Benamning: {
          AttributeName: 'Benamning',
          DisplayLabel: 'Artikelbenämning',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BenamningShort: {
          AttributeName: 'BenamningShort',
          DisplayLabel: 'Kort artikelbenämning',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
        },
        Prislista: {
          AttributeName: 'Prislista',
          DisplayLabel: 'Prislista',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.starts,
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Prislista: {
          AssociationName: 'Prislista',
          DisplayLabel: 'Prislista',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAPrislista',
          AssociatedComponentName: 'Prislista',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
        Artikel: {
          AssociationName: 'Artikel',
          DisplayLabel: 'Artikel',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAArtikel',
          AssociatedComponentName: 'Artikel',
          JoinAssociation: true,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
    LAPrislista: {
      CollectionName: 'LAPrislista',
      UDAEnabled: false,
      UDNEnabled: false,
      Properties: new Map([['NO_SELECTION', 'True']]),
      RootType: {
        TypeValue: 'Prislista',
        Abstract: false,
        SOLabel: 'Prislista',
        SOGLabel: 'Prislista',
        SBLabel: 'Prislistan',
        SBGLabel: 'Prislistan',
        POLabel: 'Prislistor',
        POGLabel: 'Prislistor',
        PBLabel: 'Prislistorna',
        PBGLabel: 'Prislistorna',
        Visible: true,
        ChildTypes: [
        ],
      },
      Attributes: {
        id: {
          AttributeName: 'id',
          DisplayLabel: 'Prislistan primärnyckel',
          DataType: 'ID',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifString',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _version: {
          AttributeName: '_version',
          DisplayLabel: 'Prislistan versionssiffra',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'Internal',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals],
          DefaultCondOperator: T.equals,
        },
        _maskvalues: {
          AttributeName: '_maskvalues',
          DisplayLabel: 'Dolda uppgifter',
          DataType: 'Boolean',
          Attribute: 'Normal',
          Condition: 'None',
        },
        _masktype: {
          AttributeName: '_masktype',
          DisplayLabel: 'Typ av skydd',
          Hint: 'Sekretess/Skyddad/Spärrad',
          DataType: 'Enum',
          EnumValues: new Map([['SEKRETESS', 'Sekretess'], ['SKYDDAD', 'Skyddad'], ['SPARRAD', 'Spärrad']]),
          EnumSortValues: new Map([['SEKRETESS', 'S'], ['SKYDDAD', 'P'], ['SPARRAD', 'L']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="SEKRETESS=Sekretess;SKYDDAD=Skyddad;SPARRAD=Spärrad"',
        },
        IDString: {
          AttributeName: 'IDString',
          DisplayLabel: 'Prislistan id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        FullIDString: {
          AttributeName: 'FullIDString',
          DisplayLabel: 'Prislistan fullständiga id-text',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        BENAMNING: {
          AttributeName: 'BENAMNING',
          DisplayLabel: 'Prislista',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'Normal',
          GUIEditable: true,
          MaxInputLength: 40,
          InterfaceType: 'ifString',
          CondOperators: [T.starts, T.notstarts, T.contains, T.notcontains, T.equals, T.notequals, T.interval, T.notinterval, T.hasvalue, T.isnull],
          DefaultCondOperator: T.contains,
          Required: true,
        },
        KUNDLEVERANTOR: {
          AttributeName: 'KUNDLEVERANTOR',
          DisplayLabel: 'Mot kund eller leverantör',
          DataType: 'String',
          Attribute: 'Normal',
          Condition: 'None',
          GUIEditable: true,
          MaxInputLength: 15,
          Required: true,
        },
        STANDARD: {
          AttributeName: 'STANDARD',
          DisplayLabel: 'Standard',
          Hint: 'Nej/Ja',
          DataType: 'Enum',
          EnumValues: new Map([['NEJ', 'Nej'], ['JA', 'Ja']]),
          EnumSortValues: new Map([['NEJ', 'N'], ['JA', 'Y']]),
          Attribute: 'Normal',
          Condition: 'None',
          Formatter: 'TEDFormatValues',
          FormatterDisplayParams: 'TranslateValues="NEJ=Nej;JA=Ja"',
          GUIEditable: true,
          Required: true,
        },
        BORTTAGEN: {
          AttributeName: 'BORTTAGEN',
          DisplayLabel: 'Logiskt borttagen',
          Hint: 'Ja/Nej',
          DataType: 'Boolean',
          Attribute: 'Internal',
          Condition: 'None',
          Formatter: 'TEDFormatBool',
        },
        BORTTAGEN_DATUM: {
          AttributeName: 'BORTTAGEN_DATUM',
          DisplayLabel: 'Borttagen datum',
          DataType: 'DateTime',
          Attribute: 'Internal',
          Condition: 'Normal',
          Formatter: 'TEDFormatDate',
          InterfaceType: 'ifNumeric',
          CondOperators: [T.equals, T.notequals, T.interval, T.notinterval, T.notless, T.greater, T.notgreater, T.less, T.hasvalue, T.isnull],
          DefaultCondOperator: T.equals,
        },
        BORTTAGEN_SIGNATUR: {
          AttributeName: 'BORTTAGEN_SIGNATUR',
          DisplayLabel: 'Borttagen signatur',
          DataType: 'String',
          Attribute: 'Internal',
          Condition: 'None',
        },
        _VERSION: {
          AttributeName: '_VERSION',
          DisplayLabel: 'Version',
          DataType: 'Int',
          Attribute: 'Internal',
          Condition: 'None',
        },
      },
      Associations: {
        Priser: {
          AssociationName: 'Priser',
          DisplayLabel: 'Priser',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'LAPriser',
          AssociatedComponentName: 'Priser',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: true,
          Integrated: false,
          Properties: new Map([]),
        },
        Kund: {
          AssociationName: 'Kund',
          DisplayLabel: 'Kund',
          Attribute: 'Normal',
          Condition: 'Internal',
          AssociatedCollectionName: 'KRKund',
          AssociatedComponentName: 'Kund',
          JoinAssociation: false,
          ValidInComps: [],
          OwnedAssociation: false,
          Integrated: false,
          Properties: new Map([]),
        },
      },
    },
  },
};

export default LA;
